import classNames from 'classnames';

type CardVariant = 'border' | 'shadow' | 'basic';

type CardProps = React.HTMLAttributes<HTMLDivElement> & {
  variant?: CardVariant;
  withoutBg?: boolean;
  rounded?: 'lg' | '2xl';
};

export const Card = ({
  children,
  variant = 'border',
  withoutBg = false,
  rounded = 'lg',
  className,
  ...props
}: CardProps) => (
  <div
    className={classNames(`p-4 rounded-${rounded}`, {
      'border border-gray-200': variant === 'border',
      'shadow-card': variant === 'shadow',
      'bg-white': !withoutBg,
      [className ?? '']: true,
    })}
    {...props}
  >
    {children}
  </div>
);
